import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ModalModule } from 'ngx-bootstrap/modal';

import { SharedModule } from 'shared/shared.module';

import { DigitalAssetsPanelComponent } from './digital-assets-panel.component';
import { DigitalAssetsFormComponent } from './digital-assets-form/digital-assets-form.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        ModalModule.forRoot(),
        TypeaheadModule.forRoot(),
    ],
    declarations: [
        DigitalAssetsPanelComponent,
        DigitalAssetsFormComponent,
    ],
    exports: [
        DigitalAssetsPanelComponent,
        DigitalAssetsFormComponent,
    ],
    providers: []
})
export class DigitalAssetsPanelModule {}
